//Get All Matrix Service Request 
export const FETCH_MATRIXSERVICE_REQUST = 'FETCH_MATRIXSERVICE_REQUST';
export const FETCH_MATRIXSERVICE_SUCCESS = 'FETCH_MATRIXSERVICE_REQUST_SUCCESS';
export const FETCH_MATRIXSERVICE_FAILURE = 'FETCH_MATRIXSERVICE_REQUST_FAILURE';

//Get All Dropdown Values
export const SITEONBOARDINGPLANNER_DROPDOWN_VALUES_REQUEST = 'SITEONBOARDINGPLANNER_DROPDOWN_VALUES_REQUEST';
export const SITEONBOARDINGPLANNER_DROPDOWN_VALUES_SUCCESS = 'SITEONBOARDINGPLANNER_DROPDOWN_VALUES_SUCCESS';
export const SITEONBOARDINGPLANNER_DROPDOWN_VALUES_FAILURE = 'SITEONBOARDINGPLANNER_DROPDOWN_VALUES_FAILURE';

//Get Worklist Details by RPCE ID
export const GETWORKLISTBY_RPCEID_REQUEST = 'GETWORKLISTBY_RPCEID_REQUEST';
export const GETWORKLISTBY_RPCEID_SUCCESS = 'GETWORKLISTBY_RPCEID_SUCCESS'; 
export const GETWORKLISTBY_RPCEID_FAILURE = 'GETWORKLISTBY_RPCEID_FAILURE';

//Get Practice Details by Worklist ID
export const GETPRACTICENAMEBY_WORKLIST_REQUEST = 'GETPRACTICENAMEBY_WORKLIST_REQUEST';
export const GETPRACTICENAMEBY_WORKLIST_SUCCESS = 'GETPRACTICENAMEBY_WORKLIST_SUCCESS';
export const GETPRACTICENAMEBY_WORKLIST_FAILURE = 'GETPRACTICENAMEBY_WORKLIST_FAILURE';

//Exporting Matrix Service Request Data
export const EXPORT_MATRIXSERVICE_REQUEST = 'EXPORT_MATRIXSERVICE_REQUEST';
export const EXPORT_MATRIXSERVICE_SUCCESS = 'EXPORT_MATRIXSERVICE_SUCCESS';
export const EXPORT_MATRIXSERVICE_FAILURE = 'EXPORT_MATRIXSERVICE_FAILURE';

//Add new Service Request
export const ADDNEW_SERVICEREQUEST_REQUEST = 'ADDNEW_SERVICEREQUEST_REQUEST';
export const ADDNEW_SERVICEREQUEST_SUCCESS = 'ADDNEW_SERVICEREQUEST_SUCCESS';
export const ADDNEW_SERVICEREQUEST_FAILURE = 'ADDNEW_SERVICEREQUEST_FAILURE';

//Bulk Save Service Requests
export const BULKSAVE_SERVICEREQUEST_REQUEST = 'BULKSAVE_SERVICEREQUEST_REQUEST';
export const BULKSAVE_SERVICEREQUEST_SUCCESS = 'BULKSAVE_SERVICEREQUEST_SUCCESS';
export const BULKSAVE_SERVICEREQUEST_FAILURE = 'BULKSAVE_SERVICEREQUEST_FAILURE';

//Delete Service Request
export const DELETEMATRIXSERVICE_REQUEST = 'DELETEMATRIXSERVICE_REQUEST';
export const DELETEMATRIXSERVICE_SUCCESS = 'DELETEMATRIXSERVICE_SUCCESS';   
export const DELETEMATRIXSERVICE_FAILURE = 'DELETEMATRIXSERVICE_FAILURE';

// Get All Onboarding Site Demand Planner
export const FETCH_ONBOARDING_SITE_DEMAND_PLANNER_REQUEST = 'FETCH_ONBOARDING_SITE_DEMAND_PLANNER_REQUEST';
export const FETCH_ONBOARDING_SITE_DEMAND_PLANNER_SUCCESS = 'FETCH_ONBOARDING_SITE_DEMAND_PLANNER_SUCCESS';   
export const FETCH_ONBOARDING_SITE_DEMAND_PLANNER_FAILURE = 'FETCH_ONBOARDING_SITE_DEMAND_PLANNER_FAILURE';

// Get All Onboarding Site Demand Planner Legend List
export const FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_REQUEST = 'FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_REQUEST';
export const FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_SUCCESS = 'FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_SUCCESS';
export const FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_FAILURE = 'FETCH_ONBOARDING_SITE_DEMAND_PLANNER_LEGEND_LIST_FAILURE';

// Update Onboarding Site Demand Planner Data

export const UPDATE_ONBOARDING_SITE_DEMAND_PLANNER_DATA_REQUEST = 'UPDATE_ONBOARDING_SITE_DEMAND_PLANNER_DATA_REQUEST';
export const UPDATE_ONBOARDING_SITE_DEMAND_PLANNER_DATA_SUCCESS = 'UPDATE_ONBOARDING_SITE_DEMAND_PLANNER_DATA_SUCCESS';
export const UPDATE_ONBOARDING_SITE_DEMAND_PLANNER_DATA_FAILURE = 'UPDATE_ONBOARDING_SITE_DEMAND_PLANNER_DATA_FAILURE';